import { State } from "../../../state";
import { ApplyActionVisibility } from "../_CostsAndOutcomes/ApplyActionVisibility";
import { ApplyCosts } from "../_CostsAndOutcomes/ApplyCosts";
import { ApplyCostScaleChange } from "../_CostsAndOutcomes/ApplyCostScaleChange";
import { meetsCostRequirements } from "../_CostsAndOutcomes/meetsCostRequirements";
import { applyAchievementChecks } from "../../../Achievements/checkAchievements";
import { upgradeAtMaxCapacity } from "../_CostsAndOutcomes/Upgrades/upgradeAtMaxCapacity";

export const UpgradeGeneric = (actionId: string, state: State) => {
  const newBricks = new Map(state.bricks);
  const newActions = new Map(state.actions);
  const newActionTimestamps = state.actionTimestamps;
  const newBrickPackUpgrades = new Map(state.brickPackUpgrades);
  const newActionsTriggeredByType = state.actionsTriggeredByType;

  const action = new Map(state.actions).get(actionId)!;

  // Check if upgrade is already at max capacity (100% find percentage for all bricks)
  if (upgradeAtMaxCapacity(action, state.actions, state.brickPackUpgrades)) {
    return state;
  }

  // Check if action meets cost requirements
  if (!meetsCostRequirements(action, newBricks)) return state;

  // Apply Action Visibility
  const { newActions: updatedActions, newActionOrder } = ApplyActionVisibility(
    action,
    newActions,
    state.actionOrder,
  );

  // Apply Costs
  // null = result of applied costs are negative. Should be caught during meetCostRequirements
  if (ApplyCosts(action, newBricks, newActionTimestamps) === null) return state;

  // Apply Upgrade: Increment the upgrade counter for the brick pack
  // For upgrade actions, the outcome[0].brickId contains the brick pack ID
  if (action.outcome.length > 0) {
    const brickPackId = action.outcome[0].brickId;
    const currentUpgrades = newBrickPackUpgrades.get(brickPackId) || 0;
    newBrickPackUpgrades.set(brickPackId, currentUpgrades + 1);
  }

  // Apply Increase in costScale
  ApplyCostScaleChange(action, updatedActions);

  // Apply Acheivement Data
  const newActionsAmt = newActionsTriggeredByType.get(actionId) ?? 0;
  newActionsTriggeredByType.set(actionId, newActionsAmt + 1);

  const newState = {
    ...state,
    actionTimestamps: newActionTimestamps,
    bricks: newBricks,
    actions: updatedActions,
    actionOrder: newActionOrder,
    brickPackUpgrades: newBrickPackUpgrades,
    totalActionsTriggered: state.totalActionsTriggered + 1,
    actionsTriggeredByType: newActionsTriggeredByType,
  };

  return applyAchievementChecks(newState);
};
